// src/services/mysqlSource.js
//
// Which MySQL data source (registered instance) a dashboard-level control --
// a query variable or a slicer -- uses when it hasn't been given one. There is
// no dashboard-level instance (mysqlInstanceId lives on each panel), so it
// inherits, in order:
//   1. the one instance every MySQL panel on this dashboard uses,
//   2. otherwise the plant's only instance,
//   3. otherwise '' -- ambiguous, the user must choose.
// The server still checks the plant may use whatever is sent.

import mysqlService from './mysql.js';

export function inheritedInstanceId(panels = [], instances = []) {
  const used = [...new Set((panels || [])
    .filter(p => p && p.dbEngine === 'mysql' && p.type !== 'slicer' && p.mysqlInstanceId)
    .map(p => p.mysqlInstanceId))];
  const available = (id) => !instances.length || instances.some(i => i.instanceId === id);
  if (used.length === 1 && available(used[0])) return used[0];
  if (instances.length === 1) return instances[0].instanceId;
  return '';
}

// One listInstances call per plant per page load; variables and slicers on
// the same dashboard share it.
const cache = new Map();   // plantId -> Promise<instances[]>
export function plantInstances(plantId) {
  if (!plantId) return Promise.resolve([]);
  if (!cache.has(plantId)) {
    cache.set(plantId, mysqlService.listInstances(plantId).catch((err) => { cache.delete(plantId); throw err; }));
  }
  return cache.get(plantId);
}
export function clearPlantInstancesCache() { cache.clear(); }
